import { EditorMode } from '../enums/editor-mode.enum';
import type { EditorModePaths } from '../types/props.type';

export const getEditorMode = (
  editorModePath: string,
  editorModePaths: EditorModePaths,
): EditorMode => {
  switch (editorModePath) {
    case editorModePaths.Info:
    case editorModePaths.InfoEdit:
    case editorModePaths.InfoEditState:
      return EditorMode.Info;
    case editorModePaths.Editor:
      return EditorMode.Editor;
    case editorModePaths.Printer:
      return EditorMode.Printer;
    case editorModePaths.Preview:
      return EditorMode.Preview;
    case editorModePaths.Generation:
      return EditorMode.Generation;
    case editorModePaths.Share:
      return EditorMode.Share;
    case editorModePaths.Summary:
      return EditorMode.Summary;
    case editorModePaths.Versions:
      return EditorMode.Versions;
    case editorModePaths.Admin:
    case editorModePaths.AdminEdit:
      return EditorMode.Admin;
    default:
      throw new Error(`Invalid path in document editor: ${editorModePath}`);
  }
};
